<div class="switch-profile">
    <button *ngIf="!(isTechView$ | async)" mat-button class="custom-switch-button" (click)="switchToTech()">
      <mat-icon>construction</mat-icon>
      Tech View
    </button>
    <button *ngIf="isTechView$ | async" mat-button class="custom-switch-button" (click)="switchToAdmin()">
      <mat-icon>supervisor_account</mat-icon>
      Admin View
    </button>
  </div>
  